export default __webpack_public_path__ + "static/logo-min-acb484b597f2a13d9f71227ed43437c6.png";